const css = `.blog-posts-page {
  display: flex;
  height: 100%;
  flex-direction: column;
}
.blog-posts-page .blog-section-card {
  box-shadow: none;
  margin-top: 16px;
}
.blog-posts-page .blog-filter-header {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: end;
}
.blog-posts-page .post-card-container {
  width: var(--row-third);
}
.blog-posts-page .post-card-container .post-card {
  padding: unset;
  overflow: hidden;
  height: 100%;
  border-radius: 16px;
  cursor: pointer;
}
.blog-posts-page .post-card-container .post-card:hover {
  transform: translateY(-2px) scale(1.01);
  box-shadow: var(--shadow-2);
}
.blog-posts-page .post-card-container .post-card .post-image {
  background-size: cover;
  aspect-ratio: 16/9;
  border-bottom-left-radius: unset;
  border-bottom-right-radius: unset;
  position: relative;
}
.blog-posts-page .post-card-container .post-card .post-image img {
  width: 100%;
  aspect-ratio: 16/9;
  object-fit: cover;
}
.blog-posts-page .post-card-container .post-card .post-image .locale-tag-container {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  gap: 8px;
  padding: 8px;
}
.blog-posts-page .post-card-container .post-card .post-image .locale-tag-container .locale-tag-item {
  background-color: var(--surface-raised);
  border: 1px solid var(--accent);
  padding: 4px;
}
.blog-posts-page .post-card-container .post-card .post-image .locale-tag-container .locale-tag-item.p-tag-warning {
  background-color: var(--warning-chip);
  border-color: var(--warning);
}
.blog-posts-page .post-card-container .post-card .post-image .locale-tag-container .locale-tag-item .p-tag-value {
  font-size: var(--font-size-sm);
  line-height: var(--line-height-none);
}
.blog-posts-page .post-card-container .post-card .post-content {
  padding: 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.blog-posts-page .post-card-container .post-card .post-content .post-description {
  min-height: 115px;
}
.blog-posts-page .post-card-container .post-card .post-content .post-footer {
  margin-top: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.blog-posts-page .post-card-container .post-card .post-content .post-footer p {
  color: var(--text-subtle);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
}
.blog-posts-page .p-dataview-content {
  container-type: inline-size;
  container-name: posts-grid;
}
.blog-posts-page .p-card-body {
  height: 100%;
}
.blog-posts-page .p-card-content {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.blog-posts-page .p-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding-top: 16px;
  padding-bottom: 16px;
}
.blog-posts-page .p-dataview-content {
  flex-grow: 1;
}
@container posts-grid (max-width: 950px) {
  .blog-posts-page .post-card-container {
    width: var(--row-half);
  }
}
@container posts-grid (max-width: 600px) {
  .blog-posts-page .post-card-container {
    width: 100%;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
